import React, { MouseEventHandler } from 'react';
import { Button, Typography } from '@mui/material';

export const Snackbar = ({
  message,
  retry,
}: {
  message: string;
  retry?: MouseEventHandler;
}) => {
  return (
    <div>
      <Typography sx={{ color: '#fff' }}>{message}</Typography>
      {retry && <Button onClick={retry}>Try again</Button>}
    </div>
  );
};
